import { render, staticRenderFns } from "./recruitManage.vue?vue&type=template&id=53efa039"
import script from "./recruitManage.vue?vue&type=script&lang=js"
export * from "./recruitManage.vue?vue&type=script&lang=js"
import style0 from "./recruitManage.vue?vue&type=style&index=0&id=53efa039&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports